// extracted by mini-css-extract-plugin
export default {"info_card_container":"styles_info_card_container__e6ktX"};